import api from './api';
export const notificationService={
  async list(page=1){return(await api.get('/notifications',{params:{page}})).data;},
  async read(id){return(await api.post(`/notifications/${id}/read`)).data;},
  async readAll(){return(await api.post('/notifications/read-all')).data;},
};
export const complaintService={
  async create(id,reason){return(await api.post(`/deposit-forms/${id}/complaints`,{reason})).data;},
  async resolve(id,resolution){return(await api.put(`/deposit-complaints/${id}/resolve`,{resolution})).data;},
};
